export enum ApiAction {
  CreateFolder = 'create-folder',
}
